import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "GM anon 👋", -1)
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" NFT Armory is a simple tool to ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("view")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("mint")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(", and ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("update")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" your Metaplex NFTs on Solana. ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, " It's primarily meant for developers / artists for quick experimentation and debugging. ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, [
  /*#__PURE__*/_createTextVNode(" Click around and have fun exploring. Also check out "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/ilmoi/awesome-solana-nfts",
    target: "_blank",
    class: "nes-text is-primary"
  }, "other awesome Solana NFT tools"),
  /*#__PURE__*/_createTextVNode("! ")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "mt-5 bg-black text-white p-5"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " I spent my childhood in MMOs, most of it in WoW. If you did too, you'll remember WoW Armory. ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, " The original idea for this tool was something that would let you view / manage / share your NFT collection. That sounded a lot like WoW Armory to me, but for NFTs, so I called it that. ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, "Dunno maybe I'm weird ¯\\_(ツ)_/¯", -1)
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: "/view",
        class: "nes-text is-primary"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5,
      _createVNode(_component_router_link, {
        to: "/mint",
        class: "nes-text is-primary"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _hoisted_7,
      _createVNode(_component_router_link, {
        to: "/update",
        class: "nes-text is-primary"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _hoisted_9
    ]),
    _hoisted_10,
    _hoisted_11,
    _createElementVNode("button", {
      class: "nes-btn is-primary mt-5",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showText = !_ctx.showText))
    }, "Why the name?"),
    (_ctx.showText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_16))
      : _createCommentVNode("", true)
  ]))
}